"use strict";

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n      flex-basis: 45%;\n    "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n          display: flex;\n          justify-content: space-between;\n          flex-wrap: wrap;\n        "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n          padding: 0 ", "px;\n      "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n          text-align: left;\n          padding: 0 ", "px;\n          flex-direction: row;\n      "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n          padding: 0 ", "px;\n      "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      margin: auto;\n      max-width: 1440px;\n      box-sizing: border-box;\n      position: relative;\n      text-align: center;\n      padding: 0 ", "px;\n  \n      flex-direction: column;\n  \n      ", "\n  \n  \n      ", "\n  \n      ", "\n  \n      ", "\n  \n      /** aside styles */\n      ", "\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n              & > :first-child {\n              order: 0;\n              }\n  \n              & > :last-child {\n              order: 1;\n              }\n          "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        & > :first-child {\n          order: 1;\n        }\n\n        & > :last-child {\n          order: 0;\n        }\n\n        ", "\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          & > :first-child {\n            order: 1;\n          }\n  \n          & > :last-child {\n            order: 0;\n          }\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        & > :first-child {\n          order: 1;\n        }\n\n        & > :last-child {\n          order: 0;\n        }\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importStar(require("styled-components"));

var bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");

var ContentBlock_1 = require("./ContentBlock");

var flipIt = function flipIt(_ref) {
  var flip = _ref.flip;

  switch (flip) {
    case ContentBlock_1.Flips.Both:
      return styled_components_1.css(_templateObject());

    case ContentBlock_1.Flips.Horizontal:
      return bitcoincom_pkg_theme_1.media.md(_templateObject2());

    case ContentBlock_1.Flips.Vertical:
      return styled_components_1.css(_templateObject3(), bitcoincom_pkg_theme_1.media.md(_templateObject4()));

    default:
      return styled_components_1.css(_templateObject5());
  }
};

exports.StyledContentBlock = styled_components_1["default"].div(_templateObject6(), function (_ref2) {
  var theme = _ref2.theme,
      aside = _ref2.aside,
      flip = _ref2.flip;
  return styled_components_1.css(_templateObject7(), theme.spacing.unit * 2, flipIt({
    flip: flip
  }), bitcoincom_pkg_theme_1.media.sm(_templateObject8(), theme.spacing.unit * 4), bitcoincom_pkg_theme_1.media.md(_templateObject9(), theme.spacing.unit * 8), bitcoincom_pkg_theme_1.media.lg(_templateObject10(), theme.spacing.unit * 16), aside && styled_components_1.css(_templateObject11()));
});
exports.Content = styled_components_1["default"].div(_templateObject12(), bitcoincom_pkg_theme_1.media.md(_templateObject13()));